module.exports = __webpack_public_path__ + "static/media/thumbsup.f58601eb.JPG";